import {
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Text,
} from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const MODAL_PLACEMENT_OFFSET_LEFT = 'calc(280px - 50%)';
const MODAL_PLACEMENT_OFFSET_TOP = '250px';

const BrandTemplateConfirmModal = () => {
  const { t } = useTranslation('editor_modals', { useSuspense: false, keyPrefix: 'brandTemplateConfirmModal' });
  const [isOpen, setIsOpen] = useState(false);
  const [brandTemplateId, setBrandTemplateId] = useState<string>('');

  const handleOnClose = () => {
    try {
      // Remove session storage key 'lastOnboardingBrandTemplateId'
      sessionStorage.removeItem('lastOnboardingBrandTemplateId');
    } catch (error) {
      console.warn('Error reading lastOnboardingBrandTemplateId from session storage', error);
    } finally {
      setBrandTemplateId('');
      setIsOpen(false);
    }
  };

  const handleKeepCurrent = () => {
    // TODO: Add mixpanel event
    handleOnClose();
  };

  const handleUseOriginTemplate = useCallback(() => {
    // onConfirm callback
    if (brandTemplateId) {
      handleOnClose();
      // Redirect to templates page
      window.location.href = `/templates?preview=${brandTemplateId}`;
    }
  }, [brandTemplateId]);

  useEffect(() => {
    // Read session storage key 'lastOnboardingBrandTemplateId'
    try {
      const lastOnboardingBrandTemplateId = sessionStorage.getItem('lastOnboardingBrandTemplateId');
      if (lastOnboardingBrandTemplateId) {
        setIsOpen(true);
        setBrandTemplateId(lastOnboardingBrandTemplateId);
      }
    } catch (error) {
      console.warn('Error reading lastOnboardingBrandTemplateId from session storage', error);
    }
  }, []);

  return (
    <Modal isOpen={isOpen} onClose={handleOnClose} closeOnOverlayClick={true}>
      <ModalContent
        maxW={'sm'}
        m='auto'
        p='0'
        top={MODAL_PLACEMENT_OFFSET_TOP}
        left={MODAL_PLACEMENT_OFFSET_LEFT}
        containerProps={{
          zIndex: 'var(--vg-zIndices-popOver)',
        }}
        bgColor={'var(--vg-colors-font-500)'}
        data-testid={'brand-template-confirm-modal'}
      >
        <ModalHeader>
          <Heading size={'sm'} color='white'>
            {t('title')}
          </Heading>
        </ModalHeader>
        <ModalCloseButton color='white' data-testid={'brand-template-confirm-close-button'} />
        <ModalBody>
          <Text fontSize={'xs'} color='white'>
            {t('content')}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant={'ghost'}
            color='white'
            size={'xs'}
            mr={2}
            whiteSpace='initial'
            minH='36px'
            onClick={handleUseOriginTemplate}
            data-testid={'use-origin-template-button'}
          >
            <Text fontSize={'xs'} color='white'>
              {t('useOriginButton')}
            </Text>
          </Button>
          <Button
            variant={'action'}
            color='white'
            bgColor='var(--vg-colors-green-500)'
            size={'xs'}
            whiteSpace='initial'
            minH='36px'
            onClick={handleKeepCurrent}
            data-testid={'keep-current-brand-template-button'}
          >
            <Text fontSize={'xs'} color='white'>
              {t('keepCurrentButton')}
            </Text>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default BrandTemplateConfirmModal;
